/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox } from '@neo4j-ndl/react';
import { useState } from 'react';

type Option = {
  label: string;
  value: string;
};

const options: Option[] = Array.from({ length: 10000 }, (_unused, index) => ({
  label: `Node ${index + 1}`,
  value: `node-${index + 1}`,
}));

const Component = () => {
  const [value, setValue] = useState(options.slice(0, 1500));

  return (
    <Combobox
      label="Nodes"
      isClearable
      isMulti
      options={options}
      value={value}
      onChange={(nextValue) => setValue(nextValue)}
      helpText="10,000 options with 1,500 selected: the list renders only its visible rows and the counter rounds to thousands."
    />
  );
};

export default Component;
